export default __webpack_public_path__ + "static/media/monthly_report_guide_ko@2x.2c6a3d14.png";